// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v7.35.0
// source: admin.proto

/* eslint-disable */
import * as _m0 from "protobufjs/minimal";
import { Users } from "./identity";
import { Orders } from "./order";
import { PositionResponse } from "./position";
import { TradingAccounts } from "./trading-bridge";

export const protobufPackage = "com.tick2trade.api.admin";

export interface GetTradingAccountsAdminRequest {
  userId?: string | undefined;
  email?: string | undefined;
  tradingAccountId?: string | undefined;
}

export interface GetTradingAccountsAdminResponse {
  users: Users | undefined;
  tradingAccounts: TradingAccounts | undefined;
}

export interface GetOrdersPositionAdminResponse {
  orders: Orders | undefined;
  positions: PositionResponse | undefined;
}

export interface DeleteUserRequest {
  userId: string;
}

function createBaseGetTradingAccountsAdminRequest(): GetTradingAccountsAdminRequest {
  return { userId: undefined, email: undefined, tradingAccountId: undefined };
}

export const GetTradingAccountsAdminRequest = {
  encode(message: GetTradingAccountsAdminRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.userId !== undefined) {
      writer.uint32(10).string(message.userId);
    }
    if (message.email !== undefined) {
      writer.uint32(18).string(message.email);
    }
    if (message.tradingAccountId !== undefined) {
      writer.uint32(26).string(message.tradingAccountId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetTradingAccountsAdminRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTradingAccountsAdminRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.userId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.email = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.tradingAccountId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetTradingAccountsAdminRequest {
    return {
      userId: isSet(object.userId) ? globalThis.String(object.userId) : undefined,
      email: isSet(object.email) ? globalThis.String(object.email) : undefined,
      tradingAccountId: isSet(object.tradingAccountId) ? globalThis.String(object.tradingAccountId) : undefined,
    };
  },

  toJSON(message: GetTradingAccountsAdminRequest): unknown {
    const obj: any = {};
    if (message.userId !== undefined) {
      obj.userId = message.userId;
    }
    if (message.email !== undefined) {
      obj.email = message.email;
    }
    if (message.tradingAccountId !== undefined) {
      obj.tradingAccountId = message.tradingAccountId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetTradingAccountsAdminRequest>, I>>(base?: I): GetTradingAccountsAdminRequest {
    return GetTradingAccountsAdminRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetTradingAccountsAdminRequest>, I>>(
    object: I,
  ): GetTradingAccountsAdminRequest {
    const message = createBaseGetTradingAccountsAdminRequest();
    message.userId = object.userId ?? undefined;
    message.email = object.email ?? undefined;
    message.tradingAccountId = object.tradingAccountId ?? undefined;
    return message;
  },
};

function createBaseGetTradingAccountsAdminResponse(): GetTradingAccountsAdminResponse {
  return { users: undefined, tradingAccounts: undefined };
}

export const GetTradingAccountsAdminResponse = {
  encode(message: GetTradingAccountsAdminResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.users !== undefined) {
      Users.encode(message.users, writer.uint32(10).fork()).ldelim();
    }
    if (message.tradingAccounts !== undefined) {
      TradingAccounts.encode(message.tradingAccounts, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetTradingAccountsAdminResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTradingAccountsAdminResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.users = Users.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.tradingAccounts = TradingAccounts.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetTradingAccountsAdminResponse {
    return {
      users: isSet(object.users) ? Users.fromJSON(object.users) : undefined,
      tradingAccounts: isSet(object.tradingAccounts) ? TradingAccounts.fromJSON(object.tradingAccounts) : undefined,
    };
  },

  toJSON(message: GetTradingAccountsAdminResponse): unknown {
    const obj: any = {};
    if (message.users !== undefined) {
      obj.users = Users.toJSON(message.users);
    }
    if (message.tradingAccounts !== undefined) {
      obj.tradingAccounts = TradingAccounts.toJSON(message.tradingAccounts);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetTradingAccountsAdminResponse>, I>>(base?: I): GetTradingAccountsAdminResponse {
    return GetTradingAccountsAdminResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetTradingAccountsAdminResponse>, I>>(
    object: I,
  ): GetTradingAccountsAdminResponse {
    const message = createBaseGetTradingAccountsAdminResponse();
    message.users = (object.users !== undefined && object.users !== null) ? Users.fromPartial(object.users) : undefined;
    message.tradingAccounts = (object.tradingAccounts !== undefined && object.tradingAccounts !== null)
      ? TradingAccounts.fromPartial(object.tradingAccounts)
      : undefined;
    return message;
  },
};

function createBaseGetOrdersPositionAdminResponse(): GetOrdersPositionAdminResponse {
  return { orders: undefined, positions: undefined };
}

export const GetOrdersPositionAdminResponse = {
  encode(message: GetOrdersPositionAdminResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.orders !== undefined) {
      Orders.encode(message.orders, writer.uint32(10).fork()).ldelim();
    }
    if (message.positions !== undefined) {
      PositionResponse.encode(message.positions, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetOrdersPositionAdminResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetOrdersPositionAdminResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.orders = Orders.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.positions = PositionResponse.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetOrdersPositionAdminResponse {
    return {
      orders: isSet(object.orders) ? Orders.fromJSON(object.orders) : undefined,
      positions: isSet(object.positions) ? PositionResponse.fromJSON(object.positions) : undefined,
    };
  },

  toJSON(message: GetOrdersPositionAdminResponse): unknown {
    const obj: any = {};
    if (message.orders !== undefined) {
      obj.orders = Orders.toJSON(message.orders);
    }
    if (message.positions !== undefined) {
      obj.positions = PositionResponse.toJSON(message.positions);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetOrdersPositionAdminResponse>, I>>(base?: I): GetOrdersPositionAdminResponse {
    return GetOrdersPositionAdminResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetOrdersPositionAdminResponse>, I>>(
    object: I,
  ): GetOrdersPositionAdminResponse {
    const message = createBaseGetOrdersPositionAdminResponse();
    message.orders = (object.orders !== undefined && object.orders !== null)
      ? Orders.fromPartial(object.orders)
      : undefined;
    message.positions = (object.positions !== undefined && object.positions !== null)
      ? PositionResponse.fromPartial(object.positions)
      : undefined;
    return message;
  },
};

function createBaseDeleteUserRequest(): DeleteUserRequest {
  return { userId: "" };
}

export const DeleteUserRequest = {
  encode(message: DeleteUserRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.userId !== "") {
      writer.uint32(10).string(message.userId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DeleteUserRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteUserRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.userId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DeleteUserRequest {
    return { userId: isSet(object.userId) ? globalThis.String(object.userId) : "" };
  },

  toJSON(message: DeleteUserRequest): unknown {
    const obj: any = {};
    if (message.userId !== "") {
      obj.userId = message.userId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DeleteUserRequest>, I>>(base?: I): DeleteUserRequest {
    return DeleteUserRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DeleteUserRequest>, I>>(object: I): DeleteUserRequest {
    const message = createBaseDeleteUserRequest();
    message.userId = object.userId ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
